/**
 * Receives an array of packets
 */
import {makeVar} from "@apollo/client";

export const drawPlaybackTimeSlider = makeVar(null);
//sets the history index when clicking on a slider segment
export const setPlaybackTimeSliderIndex = makeVar(null);
//controls the location of progress-bar on the slider when history is playing
export const setPlaybackTimeSliderActiveLocationPercentage = makeVar(null);